function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25z",
  fill: "#EA4B4B"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.517 18.125c0-.125 0-.25-.12-.375v-.125c-.362-1.125-1.328-1.875-2.535-1.875h.241S31.397 15 25 15c-6.276 0-11.103.75-11.103.75h.24c-1.206 0-2.171.75-2.534 1.875v.125c0 .125 0 .25-.12.375C11.363 19.375 11 22 11 25s.362 5.625.483 6.875c0 .125 0 .25.12.375v.125c.363 1.125 1.328 1.875 2.535 1.875h-.241S18.603 35 25 35c6.276 0 11.103-.75 11.103-.75h-.24c1.206 0 2.172-.75 2.534-1.875v-.125c0-.125 0-.25.12-.375C38.637 30.625 39 28 39 25s-.241-5.625-.483-6.875zm-9.414 7.5l-5.672 4.25c-.12.125-.241.125-.362.125-.12 0-.241 0-.362-.125a.691.691 0 0 1-.362-.625v-8.5c0-.25.12-.5.362-.625a.746.746 0 0 1 .724 0l5.672 4.25c.121.125.242.375.242.625.12.25 0 .5-.241.625z",
  fill: "#fff"
});

var SvgSourceYoutube = function SvgSourceYoutube(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_youtube.291109ca.svg";
export { ForwardRef as ReactComponent };